import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";
import { AdminAddNotesComponent } from "../admin-add-notes/admin-add-notes.component";

@Component({
  selector: "app-admin-payments",
  templateUrl: "./admin-payments.component.html",
  styleUrls: ["./admin-payments.component.css"],
})
export class AdminPaymentsComponent implements OnInit {
  tripType: any = "-1";
  failed: boolean = false;
  success: boolean = true;
  token: any;
  tripsArray: any;
  successtripsArray: any;
  failuretripsArray: any;
  paymentArray: any = [];
  payments: any = [];
  fetch_page: any = 0;
  currentPage: any = 0;
  startPage: any = 1;
  last_page: any = 1;
  document_array: any = [];
  matdialogref!: MatDialogRef<AdminAddNotesComponent>;
  perPage: any = 10;
  loading: boolean = false;
  searchtripID: any = -1;
  clear_btn: boolean = false;
  search_btn: boolean = true;
  isInputValid: boolean = false;
  previousValue: string = "";
  private lengthState: number = 0;
  @ViewChild("newItem") newItem: ElementRef;
  constructor(
    private matDialog: MatDialog,
    private services: AdminService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.pagination(1);
    let triptype = "payments";
    localStorage.setItem("tripType", triptype);
    this.getSuccessPayments(this.searchtripID);
  }

  getTripsList(selectedTripType: any) {
    this.tripType = selectedTripType;
    if (this.tripType == "-1") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getSuccessPayments(this.searchtripID);
      this.document_array = [];
    }
    // else if (this.tripType == "liveTrips") {
    //   this.fetch_page = 1;
    //   this.startPage = 1;
    //   this.getFailurePayments(this.searchtripID);
    //   this.document_array = [];
    // }
  }

  tripsStatus(type: any) {
    if (type == "success") {
      this.searchtripID = "";
      this.successtripsArray = [];
      this.failed = false;
      this.success = true;
      this.searchtripID = -1;
      this.clear_btn = false;
      this.search_btn = true;
      this.getSuccessPayments(this.searchtripID);
    } else if (type == "failure") {
      this.searchtripID = "";
      this.failuretripsArray = [];
      this.success = false;
      this.failed = true;
      // this.getFailurePayments(this.searchtripID);
    }
  }

  public addNotes(tripId: any) {
    this.matdialogref = this.matDialog.open(AdminAddNotesComponent, {
      width: "40vw",
      data: {
        _id: tripId,
        module_type: "payment",
      },
      autoFocus: false,
    });
    this.matdialogref.afterClosed().subscribe((res: any) => {
      this.getSuccessPayments(this.searchtripID);
    });
  }

  getSuccessPayments(type: any) {
    this.searchtripID = type;
    this.loading = true;
    this.services
      .getSuccessPayments(
        this.token,
        this.startPage,
        this.perPage,
        this.searchtripID
      )
      .subscribe(
        (response: any) => {
          this.loading = false;
          this.successtripsArray = response.body.data;
          this.document_array.push(response.body.meta);
          this.last_page = response.body.meta.lastPage;
        },
        (error) => {
          this.loading = false;
          this.successtripsArray = [];
          this.last_page = 1;
          if (error.status == 404) {
            return;
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  // getFailurePayments(type: any) {
  //   this.searchtripID = type;
  //   this.loading = true;
  //   this.services
  //     .getFailurePayments(
  //       this.token,
  //       this.startPage,
  //       this.perPage,
  //       this.searchtripID
  //     )
  //     .subscribe(
  //       (response: any) => {
  //         this.loading = false;
  //         this.failuretripsArray = response.body.data;

  //         this.document_array.push(response.body.meta);
  //         this.last_page = response.body.meta.lastPage;
  //       },
  //       (error) => {
  //         this.loading = false;
  //         this.failuretripsArray = [];
  //         if (error.status == 404) {
  //           return;
  //         }
  //         if (error.error.message === "jwt malformed") {
  //           this.router.navigateByUrl("admin/login");
  //           window.localStorage.clear();
  //         }
  //         if (error.error.message === "jwt expired") {
  //           this.router.navigateByUrl("admin/login");
  //           window.localStorage.clear();
  //         }
  //         if (error.error.message === "invalid signature") {
  //           this.router.navigateByUrl("admin/login");
  //           window.localStorage.clear();
  //         }
  //         this.snackBar.open(error.error.message, "Fail", {
  //           duration: 5000,
  //         });
  //       }
  //     );
  // }

  pagination(page_status: any) {
    if (page_status == "-1") {
      this.fetch_page = parseInt(this.fetch_page) - 1;
      this.currentPage = this.fetch_page;
      this.startPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.fetch_page) + 1;
      this.fetch_page = this.currentPage;
      this.startPage = this.fetch_page;
    }
    if (page_status == "first") {
      this.fetch_page = this.document_array[0].currentPage;
      this.startPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.fetch_page = this.document_array[0].lastPage;
      this.startPage = this.document_array[0].lastPage;
    }
    this.getSuccessPayments(this.searchtripID);
  }

  onInputChange(input: HTMLInputElement) {
    const value = input.value;
    const previousLength = this.previousValue.length;
    this.previousValue = value;

    const containsSpecialChars = /[^\w\d]/.test(value);
    if (containsSpecialChars) {
      input.value = value.replace(/[^\w\d]/g, "");
      this.snackBar.open("Special characters are not allowed", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (this.previousValue.length > previousLength && this.clear_btn) {
      this.callApi();
      this.search_btn = true;
      this.clear_btn = false;
    }
    this.isInputValid = value.length >= 3;
    switch (previousLength) {
      case 10:
        if (value.length === 9 && this.lengthState !== 9) {
          this.lengthState = 9;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 9:
        if (value.length === 8 && this.lengthState !== 8) {
          this.lengthState = 8;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 8:
        if (value.length === 7 && this.lengthState !== 7) {
          this.lengthState = 7;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 7:
        if (value.length === 6 && this.lengthState !== 6) {
          this.lengthState = 6;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 6:
        if (value.length === 5 && this.lengthState !== 5) {
          this.lengthState = 5;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 5:
        if (value.length === 4 && this.lengthState !== 4) {
          this.lengthState = 4;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 4:
        if (value.length === 3 && this.lengthState !== 3) {
          this.lengthState = 3;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;
      case 3:
        if (value.length === 2 && this.lengthState !== 2) {
          this.lengthState = 2;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      default:
        if (value.length >= 2) {
          this.lengthState = 0;
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;
    }

    if (value.length === 0) {
      this.resetSearch();
    }
  }

  private callApi() {
    this.searchtripID = -1;
    this.getSuccessPayments(this.searchtripID);
    this.fetch_page = 0;
    this.pagination(1);
  }

  search(value: string) {
    if (value == "") {
      this.startPage = 0;
      this.fetch_page = 0;
      this.searchtripID = "";
      this.pagination(1);
      this.fetch_page = 0;
      this.startPage = 1;
      this.getSuccessPayments(this.searchtripID);
    } else {
      this.search_btn = false;
      this.clear_btn = true;
      this.searchtripID = -1;
      this.startPage = 1;

      this.getSuccessPayments(value);
      // this.getFailurePayments(value);
    }
  }

  resetSearch() {
    this.startPage = 0;
    this.fetch_page = 0;
    this.searchtripID = "";
    this.search_btn = true;
    this.clear_btn = false;
    if (this.newItem) {
      this.newItem.nativeElement.value = "";
    }
    this.searchtripID = -1;
    this.startPage = 1;
    this.pagination(1);
    this.getSuccessPayments(this.searchtripID);
    // this.getFailurePayments(this.searchtripID);
  }
}
